<template>
    <Paper class="change-news">
        <div class="change-news-main">
            <el-form ref="form" :model="changeNewsList"  label-width="0px" :rules="rules">
                    <div class="change-news-item">
                        <span class="change-news-item-title">
                            {{$translate('lang.E3202103170001', { defaultText: '主题' })}}:
                        </span>
                        <span class="change-news-item-input">
                            <el-form-item  prop="subject">
                                <el-input type="text" v-model="changeNewsList.subject"  class="change-news-item-input-style" maxlength="200"></el-input>
                            </el-form-item>
                        </span>
                    </div>
                    <div class="change-news-item">
                        <span class="change-news-item-title">
                            {{$translate('lang.E3202110200001', { defaultText: '发布时间' })}}:
                        </span>
                        <span class="change-news-item-input">
                            <el-form-item  prop="pushTime">
                                <el-date-picker
                                type="datetime"
                                v-model="changeNewsList.pushTime"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                :placeholder="$translate('lang.E3202101280018', { defaultText: '选择日期' })">
                                </el-date-picker>
                            </el-form-item>
                        </span>
                    </div>
                    <div class="change-news-item">
                        <span class="change-news-item-title">
                            {{$translate('lang.E3202110220001', { defaultText: '来源' })}}:
                        </span>
                        <span class="change-news-item-input">
                            <el-input type="text" v-model="changeNewsList.source"  class="change-news-item-input-style" maxlength="100"></el-input>
                        </span>
                    </div>
                    <div class="change-news-item">
                        <span class="change-news-item-title">
                            {{$translate('lang.E3202110220002', { defaultText: '概述' })}}:
                        </span>
                        <span class="change-news-item-input">
                            <el-form-item  prop="summary">
                                <el-input type="textarea" :rows="5" v-model="changeNewsList.summary"  class="change-news-item-input-style" maxlength="254"></el-input>
                                <span class="summary-word">{{summarySize}}/254</span>
                            </el-form-item>
                        </span>
                    </div>
                    <div class="change-news-item change-news-item-top">
                        <span class="change-news-item-title">
                            {{$translate('lang.E3202103170024', { defaultText: '内容' })}}:
                        </span>
                        <richText :maxCount="maxCount" class="change-news-item-input" ref="textMain"></richText>
                    </div>
                    <div class="change-news-item">
                        <span class="change-news-item-title">
                            {{$translate('lang.E3202103170004', { defaultText: '动态链接' })}}:
                        </span>
                        <span class="change-news-item-input">
                            <el-form-item>
                                <el-input type="text" v-model="changeNewsList.link" class="change-news-item-input-style"></el-input>
                            </el-form-item>
                        </span>
                    </div>
                    <div class="change-news-item change-news-item-image">
                        <span class="change-news-item-title">
                            {{$translate('lang.E3202103170005', { defaultText: '上传图片' })}}:
                        </span>
                        <span class="change-news-item-input change-news-item-input-picture">
                            <img v-if="changeNewsList.ossEndpoint" :src="changeNewsList.ossEndpoint" class="alreadyUploaded" alt="" >
                            <upload-pctures ref="upload" @pushImg='pushImg'></upload-pctures>
                        </span>
                    </div>
                    <div class="change-news-item">
                        <span class="change-news-item-title">
                            {{$translate('lang.E3202103170006', { defaultText: '立即发布' })}}:
                        </span>
                        <span class="change-news-item-input">
                            <el-checkbox size="medium" :true-label=0 :false-label=1 v-model="changeNewsList.state"></el-checkbox>
                        </span>
                    </div>
            </el-form>
        </div>
        <div class="change-news-bottom">
            <el-button class="change-news-button" size="mini" @click="getBack">
                {{$translate('lang.E3202101270002', { defaultText: '取消' })}}
            </el-button>
            <el-button type="primary" size="mini" class="change-news-button" @click="save">
                {{$translate('lang.E3202103010008', { defaultText: '保存' })}}
            </el-button>
        </div>
    </Paper>
</template>
<script>
import Paper from '@/components/core/paper/Paper';
import uploadPctures from '../../../components/systemComponent/newUploadBtn';
import richText from '../../../components/systemComponent/richText';
import { searchSingleNews, changeSingleNews, newSingleNews } from '../../../api/systemManagementApi';
export default {
    name: 'changeNews',
    data() {
        return {
            id: '',
            maxCount: 2000,
            rules: {
                subject: [
                    { required: true, message: this.$translate('lang.E3202103170023', { defaultText: '请输入主题' }), trigger: 'blur' }
                ],
                pushTime: [
                    { required: true, message: this.$translate('lang.E3202103090022', { defaultText: '请选择日期' }), trigger: 'blur' }
                ],
                summary: [
                    { required: true, message: this.$translate('lang.E3202110220003', { defaultText: '请输入概述' }), trigger: 'blur' }
                ]
            },
            changeNewsList: {
                subject: '',
                content: '',
                link: '',
                state: 0,
                version: '',
                id: '',
                ossEndpoint: null,
                contentType: 0,
                pushTime: '',
                source: '',
                summary: ''
            },
            copychangeNewsList: {
                subject: '',
                content: '',
                link: '',
                state: 0,
                version: '',
                id: '',
                ossEndpoint: null,
                contentType: 0,
                pushTime: '',
                source: '',
                summary: ''
            },
            start: false
        };
    },
    computed: {
        summarySize() {
            return this.changeNewsList.summary ? this.changeNewsList.summary.length : 0;
        }
    },
    components: {
        Paper,
        uploadPctures,
        richText
    },
    methods: {
        pushImg(src) {
            this.changeNewsList.ossEndpoint = src;
        },
        // 返回
        getBack() {
            this.$nextTick(() => {
                this.$refs.form.clearValidate();
            });
            Object.keys(this.changeNewsList).forEach(key => {
                this.changeNewsList[key] = this.copychangeNewsList[key];
            });
            this.$refs.textMain.content = null;
            this.$eventBus.$emit('closeTag', this.$route);
            this.$router.go(-1);
        },

        // 保存
        save(value) {
            if (this.$refs.textMain.content) {
                this.changeNewsList.content = this.$refs.textMain.content;
            }
            this.$refs.form.validate((valid) => {
                if (valid) {
                    if (this.changeNewsList.ossEndpoint) {
                        if (this.$route.query.id) {
                            changeSingleNews(this.changeNewsList).then(res => {
                                if (res.code === '0') {
                                    this.$message.success(this.$translate('lang.EXC202102260002', { defaultText: '修改成功' }));
                                    this.$router.push({
                                        path: '/recentNews'
                                    });
                                }
                                this.id = '';
                            });
                        } else {
                            newSingleNews(this.changeNewsList).then(res => {
                                if (res.code === '0') {
                                    this.$message.success(this.$translate('lang.EXC202103010014', { defaultText: '新增成功' }));
                                    this.$router.push({
                                        path: '/recentNews'
                                    });
                                }
                                this.id = '';
                            });
                        }
                    } else {
                        this.$message.warning(this.$translate('lang.E3202103170022', { defaultText: '请上传图片' }));
                    }
                } else {
                    return false;
                }
            });
        },
        getPull(id) {
            searchSingleNews(id).then(res => {
                if (res.code === '0') {
                    Object.keys(this.changeNewsList).forEach(key => {
                        this.changeNewsList[key] = res.data[key];
                    });
                    this.$refs.textMain.content = this.changeNewsList.content;
                }
            });
        }

    },
    created() {
        if (this.$route.query.id) {
            this.getPull(this.$route.query.id);
            this.id = this.$route.query.id;
        } else {
            this.changeTemplate = true;
        }
    },
    activated() {
        if (this.$route.query.id) {
            if (this.id !== this.$route.query.id) {
                this.getPull(this.$route.query.id);
                this.id = this.$route.query.id;
            }
        } else {
            this.changeTemplate = true;
            this.$refs.textMain.content = null;
            Object.keys(this.changeNewsList).forEach(key => {
                this.changeNewsList[key] = this.copychangeNewsList[key];
            });
        }
    },
    deactivated() {
        this.$refs.form.clearValidate();
    }

};
</script>
<style lang="less">
// 页面
.change-news{
    position: relative;
    // 内容部分
    .change-news-main{
        position: absolute;
        top: 0;
        left: 16px;
        right: 0;
        bottom: 48px;
        overflow: auto;
    }
    .change-news-item{
        display: flex;
        width: 60%;
        align-items: center;
        margin: 40px 0;
        .change-news-item-title{
            width: 70px;
            text-align: right;
            font-size: 14px;
            margin-right: 10px;
        }
        .change-news-item-input{
            width: calc(100% - 100px);
            .el-form-item{
                margin-bottom: 0;
            }
            .ql-container{
                height: 200px;
            }
        }
    }
    .summary-word{
        position: absolute;
        bottom: 1px;
        right: 2px;
        padding-right: 2px;
        font-size: 12px;
        line-height: 12px;
        color: #cecece;
        background-color: #fff;
    }
    // 文本域-标题位置
    .change-news-item-top{
        align-items: flex-start;
    }
    .change-news-textarea{
        height: 88px;
    }
    // 底部按钮
    .change-news-bottom{
        height: 48px;
        position: absolute;
        bottom: 0px;
        left: 0;
        right: 0;
        background: #FFFFFF;
        box-shadow: 0 -4px 8px 0 rgba(0,0,0,0.10);
        text-align: right;
        padding-right: 10px;
        box-sizing: border-box;
        .change-news-button{
            width: 60px;
            margin-top: 12px;
            // width: 88px;
            // height: 32px;
        }
    }
    .change-news-item-input-picture{
        display: flex;
    }
    // 已上传图片样式
    .alreadyUploaded{
        width: 148px;
        height: 148px;
        margin-right: 10px;
    }
    .change-news-item-image{
        width: 80%;
    }
}
</style>